export default __webpack_public_path__ + "static/main1-c240b24f726c15f54aa01f2f71f2f990.jpg";